import styled from 'styled-components'

export const ImageContentMain = styled.div``

export const ImageContentText = styled.div`
  padding-bottom: 2rem;
`
